// #region imports

// --- Angular
import { AbstractControl, ValidatorFn } from '@angular/forms';

// #endregion

export function RangeValidator(minValue: number, maxValue: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = control.value;
    if (isNaN(value)) {
      return { rangeValidator: true };
    }
    if (parseInt(value, 10) < minValue || parseInt(value, 10) > maxValue) {
      return { rangeValidator: true };
    }

    return null;
  };
}
